module.exports = __webpack_public_path__ + "img/person-dolly-empty.f5b4163f.svg";